import { CopyIcon } from "../../../../assets/icons";
import { handleCopy } from "../../../../utils";
import styles from "./MapRefundTokenCell.module.scss";

interface MapRefundTokenCellProps {
	token?: string | null;
}

/**
 * Table cell for the MAP Refund Token column: shows a truncated token with a
 * hover tooltip (full value) and an inline copy button. Renders an em dash when
 * no refund token exists.
 */
const MapRefundTokenCell = ({ token }: MapRefundTokenCellProps) => {
	if (!token) return <span>—</span>;

	return (
		<span className={styles.cell}>
			<span className={styles.token} title={token}>
				{token}
			</span>
			<button
				type="button"
				className={styles.copyButton}
				title="Copy MAP Refund Token"
				aria-label="Copy MAP Refund Token"
				onClick={() => handleCopy(token)}
			>
				<CopyIcon className={styles.copyIcon} />
			</button>
		</span>
	);
};

export default MapRefundTokenCell;
